import { AT } from '../../../actions/actionTypes';
import { Activity, ActivityHistoryData } from './model';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';
import * as MyKeysApiTransfer from '../../../core/apis/mykeys/transfer';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import { ErrorDataResponse, ReduxState } from '../../../interfaces';
import useDispatcher from '../../../hooks/useDispatcher';
import { useSelector } from 'react-redux';
import { getNewstDate, getOldestDate } from '../../historical';

export const useTxActivities = () => {
  const { openTransfers, closedTransfers } = useSelector(
    (s: ReduxState) => s.dialogState.transferState.activities
  );
  const { doAction, doEmptyAction } = useDispatcher();

  const removeOpenLog = (a: Activity) =>
    doAction<Activity>(AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_REMOVELOG, a);

  const getMoreOpenLogs = () => {
    Logger.info(['getMoreOpenLogs'], LogArea.Redux);

    const lastLogDate = getOldestDate(openTransfers.logs);
    MyKeysApiTransfer.getOpenTransfers(undefined, lastLogDate)
      .then(MyKeysPromiseMap)
      .then((data: ActivityHistoryData) => {
        doAction<ActivityHistoryData>(
          AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_SUCCESS,
          data
        );
      })
      .catch((err: ErrorDataResponse) => {
        Logger.info([err]);
        doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_ERROR);
      });

    doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_FETCH);
  };

  const getLatestOpenLogs = () => {
    Logger.info(['getLatestOpenLogs'], LogArea.Redux);
    const firstLogDate = getNewstDate(openTransfers.logs);
    MyKeysApiTransfer.getOpenTransfers(firstLogDate)
      .then(MyKeysPromiseMap)
      .then((data: ActivityHistoryData) => {
        doAction<ActivityHistoryData>(
          AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_SUCCESS,
          data
        );
      })
      .catch((err: ErrorDataResponse) => {
        Logger.info([err]);
        doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_ERROR);
      });

    doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_FETCH);
  };

  const getMoreClosedLogs = () => {
    Logger.info(['getMoreLogs'], LogArea.Redux);
    const lastLogDate = getOldestDate(closedTransfers.logs);
    MyKeysApiTransfer.getClosedTransfers(undefined, lastLogDate)
      .then(MyKeysPromiseMap)
      .then((data: ActivityHistoryData) => {
        doAction<ActivityHistoryData>(
          AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_SUCCESS,
          data
        );
      })
      .catch((err: ErrorDataResponse) => {
        Logger.info([err]);
        doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_ERROR);
      });

    doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_FETCH);
  };

  const getLatestClosedLogs = () => {
    Logger.info(['getLatestLogs'], LogArea.Redux);
    const firstLogDate = getNewstDate(closedTransfers.logs);
    MyKeysApiTransfer.getClosedTransfers(firstLogDate)
      .then(MyKeysPromiseMap)
      .then((data: ActivityHistoryData) => {
        doAction<ActivityHistoryData>(
          AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_SUCCESS,
          data
        );
      })
      .catch((err: ErrorDataResponse) => {
        Logger.info([err]);
        doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_ERROR);
      });

    doEmptyAction(AT.DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_FETCH);
  };

  return {
    openTransfers,
    closedTransfers,
    removeOpenLog,
    getMoreOpenLogs,
    getLatestOpenLogs,
    getMoreClosedLogs,
    getLatestClosedLogs,
  };
};

export default useTxActivities;
